import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgKkp from '../../../assets/images/logo_kkp.jpg'
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import { useCallback, useEffect, useMemo, useState } from "react";
import NonlalinService from "../../../services/nonlalin/NonlalinService";
import UserService from "../../../services/user/UserService";
import { formatDateStringDateFirst, formatDateStringLocalDateINA, getNamaUPTBaru } from "../../../utilities/Utils";

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 115,
        height: 100,
    },
    headingTtd: {
        width: 250,
        height: 123,
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        fontFamily: "Arial"
    },
    textcenter: {
        fontSize: 10,
        fontFamily: "Arial",
        textAlign: "center"
    },
    textBold: {
        fontSize: 12,
        fontFamily: "Arial-Bold"
    }
})

const CetakLHPLabnll = ({ dataDisposisi, datappm }) => {
    let nonLalinService = useMemo(() => new NonlalinService(), [])
    let userService = useMemo(() => new UserService(), [])
    const [uraianUpt, setUraianUpt] = useState(null)
    const [alamatUpt, setAlamatUpt] = useState(null)
    const [kotaUpt, setKotaUpt] = useState(null)
    const [dataPetugas, setDataPetugas] = useState(null)
    const [dataDetil, setDataDetil] = useState(null)
    const [dataSpp, setDataSpp] = useState(null)
    const [dataLhpHeader, setDataLhpHeader] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!datappm?.nomorAju || !dataDisposisi?.noTugas) {
            console.warn("datappm atau dataDisposisi belum tersedia");
            return;
        }
        try {
            const resUpt = await userService.getUptById(datappm.kodeUpt)
            setUraianUpt(getNamaUPTBaru(dataDisposisi.tglTugas, resUpt.data))
            setAlamatUpt(resUpt.data.alamatUnit)
            setKotaUpt(resUpt.data.kota)

            const resLhpHeader = await nonLalinService.getNonlalinLhpHeader(datappm?.nomorAju, dataDisposisi?.noTugas)

            if (resLhpHeader.data) {
                setDataLhpHeader(resLhpHeader.data)
                const resSpp = await nonLalinService.getNonlalinPenugasanByAjuAndNomor(datappm?.nomorAju, resLhpHeader?.data?.nomorSpp)
                setDataSpp(resSpp?.data)

                const resPetugas = await nonLalinService.listNonlalinPenugasanDetil(datappm?.nomorAju, resSpp?.data?.noTugas)
                setDataPetugas(resPetugas.data)

                const resLhpDetil = await nonLalinService.listNonlalinLhpComplete(datappm?.nomorAju)
                setDataDetil(resLhpDetil?.data?.data)

            }
        } catch (error) {

        }

    }, [dataDisposisi, datappm, userService, nonLalinService])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={[styles.tableRow, { borderBottom: 2, borderBottomStyle: 'solid' }]}>
                        <View style={[styles.tableCol, { width: '25%' }]}>
                            <Image style={styles.headingImg} src={imgKkp} />
                        </View>
                        <View style={[styles.tableCol, { width: '75%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#0000ff' }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#0000ff' }]}>BADAN PENGENDALIAN DAN PENGAWASAN MUTU</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#0000ff' }]}>HASIL KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#0000ff' }]}>{uraianUpt}</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>{alamatUpt}</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>LAPORAN HASIL PEMERIKSAAN LABORATORIUM</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>No. {dataDisposisi?.noTugas}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Berdasarkan surat perintah pemeriksaan laboratorium No. {dataSpp?.noTugas}. tanggal {dataSpp ? formatDateStringDateFirst(dataSpp.tglTugas) : null} untuk pemilik sebagai berikut :</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>a.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '24%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nama Perusahaan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{datappm?.namaTrader}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>b.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '24%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Alamat</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{datappm?.alamatTrader}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>c.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '24%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nomor Permohonan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{datappm?.nomorAju}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>d.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '24%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tanggal Permohonan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{datappm ? formatDateStringLocalDateINA(datappm.tanggalAju) : null}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>e.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '24%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tanggal Diagnosa</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>:</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '70%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataLhpHeader ? formatDateStringLocalDateINA(dataLhpHeader.tglDiagnosa) : null}</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Dengan hasil pemeriksaan produk hasil perikanan sebagai berikut :</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.tableCer3}>
                    <View style={[styles.tableRow, { borderTop: 1 }]}>
                        <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1, borderLeftWidth: 1 }]}>
                            <Text style={styles.textcenter}>No.</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "33%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Nama Sampel</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Jumlah Sampel</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "33%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Pemeriksaan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Jumlah Pengujian</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1 }]}>
                            <Text style={styles.textcenter}>Hasil</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.tableCer3}>
                    {
                        dataDetil && dataDetil.map((dtl, idx) => {
                            return <>
                                <View key={idx} style={[styles.tableRow, { borderTop: 1 }]}>
                                    <View style={[styles.tableCol, { width: "4%", borderRightWidth: 1, borderLeftWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.textcenter}>{idx+1}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "33%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.textcenter}>{dtl.namaLokal}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.textcenter}>{dtl.jumlahSample}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "33%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.textcenter}>{dtl.jenisPengujian}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.textcenter}>{dtl.jumlahPengujian}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                        <Text style={styles.textcenter}>{dtl.hasilPengujian}</Text>
                                    </View>
                                </View>
                            </>
                        })
                    }
                </View>
                <View style={styles.table}>
                    <View style={[styles.tableRow, { marginBottom: 10 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Pemeriksa 	:</Text>
                        </View>
                    </View>
                </View>
                <View style={styles.table}>
                    {
                        dataPetugas && dataPetugas.map((ptg, idx) => {
                            return <View key={idx} style={[styles.tableRow, { marginBottom: 10 }]}>
                                <View style={[styles.tableCol, { width: '3%' }]}>
                                    <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{idx + 1}</Text>
                                </View>
                                <View style={[styles.tableCol, { width: '96%' }]}>
                                    <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{ptg.namaPetugas}/ {ptg.nipPetugas}</Text>
                                </View>
                            </View>
                        })
                    }
                </View>
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{kotaUpt}, {dataDisposisi ? formatDateStringLocalDateINA(dataDisposisi.tglTugas) : null}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kepala {uraianUpt},</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '60%', marginVertical: 15 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%', marginVertical: 15 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '60%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataLhpHeader?.nmTtd}</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { width: '50%', paddingTop: 100 }]}>
                    <View style={styles.table}>
                        <View style={[styles.tableRow, { marginBottom: 10 }]}>
                            <View style={[styles.tableCol, { width: '100%' }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Catatan :</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableCer3}>
                        <View style={[styles.tableRow, { borderTop: 1 }]}>
                            <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1, borderLeftWidth: 1 }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>1</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "90%", borderRightWidth: 1 }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Hasil diagnosa ini hanya berlaku untuk contoh yang di diagnosa</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.tableCer3}>
                        <View style={[styles.tableRow, { borderTop: 1 }]}>
                            <View style={[styles.tableCol, { width: "10%", borderRightWidth: 1, borderLeftWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>2</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "90%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Laporan hasil diagnosa tidak boleh digandakan, kecuali secara lengkap seijin tertulis dari manajer puncak UPT {uraianUpt}</Text>
                            </View>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default CetakLHPLabnll